

























import { Component, Vue } from "vue-property-decorator";
// import MainHeader from "./MainPage/Header.vue"
@Component({
  components: {},
})
export default class ExternalFacingView extends Vue {
  drawer = false;
  takeToPage(place: string): void {
    this.$router.push({ name: place });
  }

  mounted() {
    // document.getElementById("loading")!.style.display = "none";
    // document.getElementById("app")!.style.display = "block";
  }
}
